import { themeVariables } from "Components/theme";
import { createOptions, RichEditUnit, ViewType } from "devexpress-richedit";
import noop from "lodash/noop";
export default (readOnly, width, height) => {
    const options = createOptions();
    if (options.bookmarks) {
        options.bookmarks.visibility = true;
        options.bookmarks.color = themeVariables["brand-danger-400"];
    }
    if (options.confirmOnLosingChanges) {
        options.confirmOnLosingChanges.enabled = true;
    }
    if (options.fields) {
        options.fields.updateFieldsBeforePrint = true;
        options.fields.updateFieldsOnPaste = true;
    }
    if (options.mailMerge) {
        options.mailMerge.activeRecord = 2;
        options.mailMerge.viewMergedData = true;
    }
    options.events.activeSubDocumentChanged = noop;
    options.events.autoCorrect = noop;
    options.events.calculateDocumentVariable = noop;
    options.events.characterPropertiesChanged = noop;
    options.events.contentInserted = noop;
    options.events.contentRemoved = noop;
    options.events.documentChanged = noop;
    options.events.documentFormatted = noop;
    options.events.documentLoaded = noop;
    options.events.gotFocus = noop;
    options.events.hyperlinkClick = noop;
    options.events.keyDown = noop;
    options.events.keyUp = noop;
    options.events.paragraphPropertiesChanged = noop;
    options.events.lostFocus = noop;
    options.events.pointerDown = noop;
    options.events.pointerUp = noop;
    options.events.saving = noop;
    options.events.saved = noop;
    options.events.selectionChanged = noop;
    options.events.customCommandExecuted = (_, e) => {
        switch (e.commandName) {
            case "insertEmailSignature":
                break;
            default:
                break;
        }
    };
    options.unit = RichEditUnit.Inch;
    if (options.view) {
        options.view.viewType = ViewType.PrintLayout;
        if (options.view.simpleViewSettings)
            options.view.simpleViewSettings.paddings = {
                left: 15,
                top: 15,
                right: 15,
                bottom: 15
            };
    }
    options.readOnly = readOnly;
    if (width)
        options.width = `${width}px`;
    if (height)
        options.height = `${height}px`;
    return options;
};
